module.exports = __webpack_public_path__ + "img/tuijian2.e7b323b8.png";